export default __webpack_public_path__ + "static/media/typescript.293600d8.svg";